import './styles.css';

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import type { IBaseCall, IBaseProps, Result } from 'bz-core-controls/modal-new/confirmation';

import ClickDialog from 'click-controls/controls/dialog';
import Button from 'click-controls/controls/form/button';
import React from 'react';
import ErrorPanel from '../error-panel';
import Actions from './controls/actions';

export interface IAlertCall extends IBaseCall {
  okLabel: string;
}

export interface IAlertDialogProps extends IBaseProps {
  okLabel?: string;
  hideActions: boolean;

  onOk: () => void;
}

export type AlertResult = Result.yes;

class AlertDialog extends React.Component<IAlertDialogProps> {
  render() {
    const { className, hasErrors } = this;
    const {
      actionProps,
      contents,
      contentProps,
      dialogProps,
      errors,
      errorsTitle,
      open,
      okLabel = 'OK',
      title = 'Warning',
      hideActions = false,
      titleProps,
      onErrorsOk,
      onErrorsCancel,
      onOk
    } = this.props;

    let actions;
    let errorPanel;
    if (hasErrors) {
      errorPanel = (
        <ErrorPanel
          className={this.props.className}
          errors={errors as string[]}
          title={errorsTitle}
          onOk={onErrorsOk}
          onCancel={onErrorsCancel}
        />
      );
    } else if (!hideActions) {
      actions = (
        <Actions className={className} actionProps={actionProps} label={okLabel} onClick={onOk} />
      );
    }

    if (!!process.env.isClick) {
      return (
        <ClickDialog
          containerClass={`max-h-full ${className}`}
          bodyClass="max-h-96 overflow-y-auto"
          width="1/3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-1/2"
          isOpen={open}
          title={title}
          centered={true}
          closable={false}
          footer={<div className={'flex flex-wrap justify-end gap-3 px-6 pt-6'}>{actions}</div>}
        >
          {contents}
          {errorPanel}
        </ClickDialog>
      );
    }
    return (
      <Dialog
        {...dialogProps}
        classes={{ container: `${className} !items-center justify-center` }}
        className={`${className} dialog`}
        open={open}
      >
        <DialogTitle {...titleProps} className={`${className} title`}>
          {title}
        </DialogTitle>
        <DialogContent {...contentProps} className={`${className} content`}>
          {contents}
          {errorPanel}
        </DialogContent>
        {actions}
      </Dialog>
    );
  }

  private get className(): string {
    const { className } = this.props;
    const classNames = ['bz-controls bz-modal alert-dialog'];

    if (!!className) {
      classNames.push(className);
    }

    return classNames.join(' ');
  }

  private get hasErrors(): boolean {
    const { errors } = this.props;

    return !!errors && errors.length > 0;
  }
}

export default AlertDialog;
